import { kebabCase } from 'lodash'

export const toKebabCaseTag = (componentType: string): string => kebabCase(componentType)
